"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgDesktopFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M9 18.007H4.014C2.671 18.007 2 17.342 2 16.01v-1.995h20v-1.997H2V4.033c0-1.322.667-1.987 2-1.996 1.25-.01 6.596-.077 16.04-.002 1.307.01 1.96.676 1.96 1.998V16.01c0 1.33-.667 1.996-2 1.996h-5l1 1.997h1c.667 0 1 .332 1 .998 0 .665-.333.998-1 .998H7c-.667 0-1-.333-1-.998 0-.666.333-.998 1-.998h1l1-1.997v.001z' }))); };
exports.default = SvgDesktopFilled;
//# sourceMappingURL=DesktopFilled.js.map